import React, { useState, useEffect } from "react"
import "../styles/main.scss"
import axios from "axios"
import Header from "./header"
import HeaderHome from "./headerHome"
import OverlayGrid from "./OverlayGrid"

export default function Layout({ children }) {
  const [activation, setActivation] = useState(true)
  const path = typeof window !== "undefined" && window.location.pathname;
  useEffect(() => {
    async function getApproval() {
      try {
        const baseURL = `https://us-central1-tectonicadata.cloudfunctions.net/getDomain?domain=${process.env.GATSBY_TEST}`
        let response = await axios.get(baseURL)
        let data = response?.data
        data.status !== true && setActivation(false)
      } catch (error) {
        console.log(error)
      }
    }

    getApproval()
  }, [])

  return (
    <>
      <OverlayGrid show={false} />
      {/* {activation && (
        <>
          <Header />
          {children}
        </>
      )} */}
      <>
        { path === '/' && <HeaderHome /> }
        { path !== '/' && <Header /> }
        {children}
      </>
    </>
  )
}
